module.exports = __webpack_public_path__ + "static/media/drag-icon.08ba6e92.svg";